import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { getConfig, localStorage } from 'src/helpers'
import { isGenericReseller } from '@grupoboticario/barril-del-chavo'

export const STATE_KEY = 'state'
export const RE_KEY = 're'
export const UF_PARAM = 'uf'
export const REGION_KEY = 'region'

export const REGION_STATE_ENUM: any = {
  COSEN: 'MG',
  COSE: 'MG',
  NE: 'AL',
  NNE: 'AL',
  SSP: 'PR',
}

export const getUfFromStorage = () => localStorage.get<string>(STATE_KEY)

const config = getConfig()

export const useUf = () => {
  const [searchParams] = useSearchParams()
  const { region, reseller: catalogSlug } = useParams<{ region: string; reseller: string }>()
  const ufStateParam = searchParams.get(UF_PARAM)

  const storagedUF = ufStateParam?.toUpperCase() || config.genericUser.addressHomeState
  const currentUF = region ? REGION_STATE_ENUM[region.toUpperCase()] : storagedUF

  useEffect(() => {
    if (isGenericReseller(catalogSlug)) {
      localStorage.set(STATE_KEY, currentUF, false)
    }

    localStorage.set(REGION_KEY, region || '', false)
  }, [catalogSlug, currentUF, region, ufStateParam])

  return currentUF
}
